<div class="PGNotificationList">
    @if (!isLoading && notifications.length == 0) {
        <div class="text-muted">
            Nessuna notifica
        </div>
    }
    @for (notification of notifications; track notification; let i = $index) {
        <div class="{{ i > 0 ? 'mt-3' : '' }}">
            <app-pg-notification [notification]="notification"></app-pg-notification>
        </div>
    }
    @if (isLoading) {
        <div>
            <app-pg-loading></app-pg-loading>
        </div>
    }
    <app-pg-view-more [hidden]="isLoading || isAtEnd" (viewMore)="checkLoad()"></app-pg-view-more>
</div>
